export const pagamentoDefaultJson = {
  filiale: '',
  data: '',
  prezzoTotale: 0,
  prezzoRimanente: 0,
  totaleValore: 0,
  numeroScontrino: '',
  dataScontrino: '',
  oraScontrino: 0,
  dispositivoScontrino: '',
  codiceFilialeDispositivo: '',
  codiceFilialeDispositivoDefault: '',
  dispositivoVisible: false,
  registratoriTelematici: [],
  focusRTConfigurato: false,
  focusRTLicenze: 0,
  noStampaDefault: false,
  lblAnteprimaDoc: '',
  anteprimaScontrinoWeb: [],
  registraDatiScontrino: false,
  ricevutoDatiScontrinoRT: false,
  scontrinoNoSconto: false,
  scontrinoStampaZero: false,
  stoPagandoUnReso: false,
  resoLotteria: false,
  resoRicevutaFiscale: false,
  tipoDocumentoReso: '',
  isDocRFE: false,
  articoliDetraibili: false,
  emettiFatturaB2B: false,
  inserimentoLiberoCodice: false,
  stampaScontrino: false,
  stampaScontrinoEnabled: false,
  stampaScontrinoVisible: false,
  lblStampaScontrinoAttivaVisible: false,
  stampaScontrinoCortesia: false,
  partecipaLotteria: false,
  lotteriaEnabled: false,
  lotteriaVisible: false,
  testCodiceLotteria: false,
  codiceLotteria_aux: '',
  opposizione: false,
  opposizioneEnabled: false,
  opposizioneVisible: false,
  nonRegistrare: false,
  nonRegistrareEnabled: false,
  scontrinoParlanteSi: false,
  scontrinoParlanteSiEnabled: false,
  scontrinoParlanteNo: false,
  scontrinoParlanteNoEnabled: false,
  panelDatiScontrinoVisible: false,
  numeroEnabled: false,
  dataEnabled: false,
  codiceFiscaleEnabled: false,
  codiceFiscaleVisible: false,
  codiceFiscale: '',
  codiceFiscaleCliente: '',
  codiceFiscaleClienteOk: false,
  codiceFiscale_aux: '',
  backupCodiceFiscale: '',
  lblCodice: '',
  btnConfermaCFVisible: false,
  infoSTSVisible: false,
  infoSTS2Visible: false,
  btnArrotondamentoEnabled: false,
  btnArrotondamentoVisible: false,
  noPagamentoDefault: false,
  abilitaMultiPagamento: false,
  numeroMetodiPagamentoSelezionati: 0,
  totaleImportiMetodiPagamento: 0,
  abilitaArrotondamentoContanti: false,
  arrotondamentoContantiEseguito: false,
  restoContanti: 0,
  importoContanti: 0,
  strContantiAux: '',
  importoContantiReadOnly: false,
  contantiChecked: false,
  contantiEnabled: false,
  importoPOS: 0,
  strPosAux: '',
  importoPosReadOnly: false,
  pOSChecked: false,
  pOSEnabled: false,
  importoNexi: 0,
  strNexiAux: '',
  importoNexiReadOnly: false,
  nexiChecked: false,
  nexiEnabled: false,
  importoVisa: 0,
  strVisaAux: '',
  importoVisaReadOnly: false,
  visaChecked: false,
  visaEnabled: false,
  importoMaster: 0,
  strMasterCardAux: '',
  importoMasterReadOnly: false,
  masterChecked: false,
  masterEnabled: false,
  importoAmerican: 0,
  strAmericanExpAux: '',
  importoAmericanReadOnly: false,
  americanChecked: false,
  americanEnabled: false,
  importoAssegno: 0,
  strAssegnoAux: '',
  importoAssegnoReadOnly: false,
  assegnoChecked: false,
  assegnoEnabled: false,
  importoBuono: 0,
  strBuonoMultiusoAux: '',
  pnlBuonoMultiusoVisible: false,
  importoBuonoMultiusoReadOnly: false,
  buonoChecked: false,
  buonoEnabled: false,
  importoFondo: 0,
  strFondoAux: '',
  pnlFondoVisible: false,
  importoFondoReadOnly: false,
  fondoChecked: false,
  fondoEnabled: false,
  importoAltro: 0,
  strAltroAux: '',
  descrizioneAltro: '',
  importoAltroReadOnly: false,
  altroChecked: false,
  altroEnabled: false,
  numeroDispositivi: 0,
  scontrinoAPartitaIVA: false,
  pagamentoNoDocumento: false,
  nonRegistrareConDoc: false,
  cassaPresente: false,
  controlloDriverAndFirmware: false,
  lotteriaDocumenti: false,
  codiceBonusVista: '',
  importoBonusVistaDefault: 0,
  importoBonusVistaMassimo: 0,
  importoBonusVista: 0,
  strBonusVistaAux: '',
  pnlBonusVistaVisible: false,
  importoBonusVistaReadOnly: false,
  bonusVistaChecked: false,
  bonusVistaEnabled: false,
};
